import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { PageCountDropdown, PagesNavigator } from './components';
import { TableWrapper, Tbl, Footer } from "./atoms";
import PropTypes from 'prop-types';

export const Table = forwardRef((props, ref) => {

  const {
    headerRow,
    tableRows,
    itemsPerPage,
    setItemsPerPage,
    totalItemsCount,
    currentPage,
    onSelectPage,
    height,
    width,
    notPadded,
  } = props;

  const tbodyRef = useRef(null);

  const [showVerticalShadow, setShowVerticalShadow] = useState(false);
  const [showHorizontalShadow, setShowHorizontalShadow] = useState(false);

  useImperativeHandle(ref, () => ({
    scrollToTop() {
      if (tbodyRef && tbodyRef.current) {
        tbodyRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      }
    }
  }));

  const handleScroll = (event) => {
    const target = event.target;
    if (target.scrollTop) {
      if (target.scrollTop < 10 && showHorizontalShadow) {
        setShowHorizontalShadow(false);
      } else if (target.scrollTop >= 10 && !showHorizontalShadow) {
        setShowHorizontalShadow(true);
      }
    }

    if (target.scrollLeft) {
      if (target.scrollLeft < 10 && showVerticalShadow) {
        setShowVerticalShadow(false);
      } else if (target.scrollLeft >= 10 && !showVerticalShadow) {
        setShowVerticalShadow(true);
      }
    }
  }

  return (
    <div className="flex-grow overflow-hidden relative" >
      <div className="absolute flex flex-col left-0 right-0 top-0 bottom-0">
        <TableWrapper width={width} height={height} ref={tbodyRef} onScroll={handleScroll}>
          <Tbl notPadded={notPadded} showHorizontalShadow={showHorizontalShadow} showVerticalShadow={showVerticalShadow}>
            <thead>
              {headerRow}
            </thead>
            <tbody>
              {tableRows}
            </tbody>
          </Tbl>
        </TableWrapper>
       {totalItemsCount!==0 &&< Footer className="mt-2">
          <div>
            <PagesNavigator pagesCount={Math.ceil(totalItemsCount / itemsPerPage)} onSelect={onSelectPage} currentPage={currentPage} />
          </div>
          <div className="flex items-center">
            <div>View</div>
            <div className="mx-1.5">
              <PageCountDropdown onSelect={setItemsPerPage} elementsCount={itemsPerPage} />
            </div>
            <div>items per page</div>
          </div>
          <div> {currentPage * itemsPerPage + 1} - {currentPage * itemsPerPage + (tableRows?.length || 0)} out of {totalItemsCount} items</div>
        </Footer>}
      </div>
    </div >
  )
})

Table.propTypes = {
  headerRow: PropTypes.node,
  tableRows: PropTypes.arrayOf(PropTypes.node),
  height: PropTypes.string,
  width: PropTypes.string,
  itemsPerPage: PropTypes.number.isRequired,
  setItemsPerPage: PropTypes.func.isRequired,
  totalItemsCount: PropTypes.number.isRequired,
  onSelectPage: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
};